import React from 'react';
import CalendarIcon from 'components/icon/calendar-icon';
import { buildClassName } from 'utils/build-class-name';
import styles from './style.module.scss';
import { testIds } from 'constants/test-constants';

import type Listing from 'data/listing';

interface Props {
  openHouses: Listing['openHouses'];
}

export default function ListingOpenHouses({ openHouses }: Props) {
  const validOpenHouses = openHouses?.filter(openHouse => openHouse.date && new Date() < new Date(openHouse?.date));
  const hasOpenHouses = (validOpenHouses || []).length > 0;

  return hasOpenHouses && validOpenHouses ?
    <div className={styles['open-house']}>
      <div data-testid={testIds.openhousesTitle}>
        <CalendarIcon />
        Open House
      </div>
      <div>
        {validOpenHouses.map((openHouse, index) => (
          <span className={buildClassName(!openHouse.isActive && styles.inactive)} key={index}>
            {openHouse.label}
          </span>
        ))}
      </div>
    </div> : null;
}
